"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _formGroup = _interopRequireDefault(require("../../../core/form-group"));
var _rowConfig = _interopRequireDefault(require("../../../core/row-config"));
var _label = _interopRequireDefault(require("../../../core/label"));
var _col = _interopRequireDefault(require("../../../core/col"));
var _editableField = _interopRequireDefault(require("../../../core/editable-field"));
var _requestYearbookDetails = _interopRequireDefault(require("./requestYearbookDetails"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement(_label.default, null, /*#__PURE__*/_react.default.createElement("strong", null, "Publish Date"));
var _ref2 = /*#__PURE__*/_react.default.createElement(_col.default, null, "This is the date on which organisers can start submitting applications to run competitions");
var _ref3 = /*#__PURE__*/_react.default.createElement(_label.default, null, /*#__PURE__*/_react.default.createElement("strong", null, "Closing Date"));
var _ref4 = /*#__PURE__*/_react.default.createElement(_col.default, null, "On or after this date organisers cannot submit applications and cannot change application dates, sites or tiers, but the calendar officer can do so (until the application has been accepted). This date should usually be set to shortly before ACM. Organisers can continue to update additional information.");
var _ref5 = /*#__PURE__*/_react.default.createElement(_label.default, null, /*#__PURE__*/_react.default.createElement("strong", null, "Approval Date"));
var _ref6 = /*#__PURE__*/_react.default.createElement(_label.default, null, /*#__PURE__*/_react.default.createElement("strong", null, "Finalised Date"));
var _ref7 = /*#__PURE__*/_react.default.createElement(_col.default, null, "After this date all fields are locked and cannot be changed. This corresponds to submitting calendar for printing");
class CalendarControlDates extends _react.Component {
  render() {
    return /*#__PURE__*/_react.default.createElement(_rowConfig.default, {
      columns: [{
        sm: 3
      }, {
        sm: 6
      }, {
        sm: 3
      }]
    }, /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref, _ref2, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: true,
      type: "Date",
      name: "publishDate",
      value: this.props.calendar.publishDate,
      onChange: this.props.onUpdate,
      placeHolder: "Click to Add Date"
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref3, _ref4, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: true,
      type: "Date",
      name: "closingDate",
      value: this.props.calendar.closingDate,
      onChange: this.props.onUpdate,
      placeHolder: "Click to Add Date"
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref5, /*#__PURE__*/_react.default.createElement(_col.default, null, "Date on which calendar approved - usually at ACM ", /*#__PURE__*/_react.default.createElement(_requestYearbookDetails.default, {
      calendar: this.props.calendar
    })), /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: this.props.calendar.closingDate,
      type: "Date",
      name: "approvalDate",
      value: this.props.calendar.approvalDate,
      onChange: this.props.onUpdate,
      placeHolder: this.props.calendar.closingDate ? 'Click to Add Date' : false
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref6, _ref7, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: this.props.calendar.approvalDate,
      type: "Date",
      name: "finalisedDate",
      value: this.props.calendar.finalisedDate,
      onChange: this.props.onUpdate,
      placeHolder: this.props.calendar.approvalDate ? 'Click to Add Date' : false
    }))));
  }

  // *******************************************************************************
  // Partial Queries
  // *******************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(CalendarControlDates, "partialQueries", {
  Calendar: _mergeBqlQueries({
    id: true,
    publishDate: true,
    closingDate: true,
    approvalDate: true,
    finalisedDate: true
  }, _requestYearbookDetails.default.partialQueries.Calendar)
});
var _default = exports.default = (0, _reactBicycle.connect)(CalendarControlDates, undefined, (client, props) => ({
  onUpdate(value, field) {
    return client.update('Calendar.set', {
      id: props.calendar.id,
      field,
      value
    });
  }
}));